import Layout from '../layouts/layout';
import { Page } from '../components/page/page';

type AboutUsPageProps = {};

export default function AboutUsPage(_props: AboutUsPageProps) {
  return (
    <Layout title="About us">
      <Page title="About us">
        <p>
          As Japanese teachers, we would love to support you in finding the right school for you. The Japanese teachers
          in the JP School Guide team have met students who felt the Japanese schools where they were studying didn’t
          really suit them - be it, their learning style, the books used, the class size, etc.
        </p>
        <p>
          As Japanese teachers, we don't like hearing about students having less than the best possible experience while
          learning Japanese, and so we hope for all students to find their ideal school.
        </p>
        <p>
          There are so many school options in Japan, all with different type of courses. It can be difficult when trying
          to select the the right school from outside of Japan when there is limited information available - even the
          schools websites can be lacking!
        </p>
        <p>So we are here to help you for the find the best school.</p>
      </Page>
    </Layout>
  );
}
